import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CircularProgress
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import startCase from 'lodash/startCase';
import { useStyles } from '../eligibility.styles';
import { ListContextProvider } from 'react-admin';

/**
 * FacilityHistoryModal component - displays a history of changes to a facility
 * @param {Object} props - Component props
 * @param {boolean} props.open - Whether the modal is open
 * @param {Function} props.onClose - Function to call when modal is closed
 * @param {Array} props.historyData - Array of history records
 */
export const FacilityHistoryModal = ({
  open,
  onClose,
  historyData = [],
  isLoading = false,
}) => {
  const classes = useStyles();

  const listContextValue = {
    data: historyData,
    ids: historyData.map((record, index) => index),
    total: historyData.length,
    isLoading: isLoading,
    perPage: 25,
    currentSort: { field: 'created_at', order: 'DESC' },
    resource: 'facility-history',
    selectedIds: [],
    setSort: () => {},
    showFilter: () => {},
    hideFilter: () => {},
    setFilters: () => {},
    displayedFilters: {},
    filterValues: {},
    setPage: () => {},
    setPagination: () => {},
    setPerPage: () => {},
    setSelectedIds: () => {},
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth='lg' fullWidth>
      <DialogTitle>
        <div className={classes.title}>Facility History</div>
        <IconButton
          aria-label='close'
          style={{
            position: 'absolute',
            right: 8,
            top: 8,
          }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <div style={{ overflowX: 'auto' }}>
          <ListContextProvider value={listContextValue}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Event</TableCell>
                  <TableCell>Update Date</TableCell>
                  <TableCell>Updated By</TableCell>
                  <TableCell>Previous Values</TableCell>
                  <TableCell>New Values</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <TableRow>
                    <TableCell colSpan={5} align='center'>
                      <CircularProgress size={24} />
                    </TableCell>
                  </TableRow>
                ) : historyData.length > 0 ? (
                  historyData.map((record, index) => (
                    <TableRow key={index}>
                      <TableCell>{record.table_name}</TableCell>
                      <TableCell>
                        {new Date(record.created_at).toLocaleString()}
                      </TableCell>
                      <TableCell>
                        {`${record['user.last_name'] || ''}, ${record[
                          'user.first_name'
                        ] || ''}`}
                      </TableCell>
                      <TableCell>
                        {Object.entries(record.prev_value || {}).map(
                          ([field, value], i) => (
                            <div key={i}>
                              {startCase(field)}:{' '}
                              {value ? startCase(String(value)) : 'N/A'}
                            </div>
                          ),
                        )}
                      </TableCell>
                      <TableCell>
                        {Object.entries(record.value || {}).map(
                          ([field, value], i) => (
                            <div key={i}>
                              {startCase(field)}:{' '}
                              {value ? startCase(String(value)) : 'N/A'}
                            </div>
                          ),
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={5} align='center'>
                      No history records found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </ListContextProvider>
        </div>
      </DialogContent>
    </Dialog>
  );
};
